import $ from 'jquery';
const ELEMENT_SELECTOR = '*[data-tab]';
export class TabsWithLinks {
    static queryValues = {};
    static init($root = $('body')) {
        const $tabElement = $root.find(ELEMENT_SELECTOR);
        if (!$tabElement.length) {
            return;
        }
        if (location.search) {
            this.queryValues = Object.fromEntries(new URLSearchParams(location.search));
        }
        if (this.queryValues.tab || this.queryValues.tab_item) {
            let $tab = $root.find(`*[data-tab="${this.queryValues.tab}"]`);
            if (!$tab.length) {
                const $tabItem = $root.find(`*[data-tab-item="${this.queryValues.tab_item}"]`);
                const $tabContent = $tabItem.closest('*[data-tab]');
                $tab = $root.find(`*[data-tab="${$tabContent.data('tab')}"]`);
            }
            this.removeAllActiveTabs($tabElement);
            $tab.trigger('click');
            $tab.addClass('active');
        }
        else {
            let $defaultTab = $root.find(`.js__default-tab`);
            if ($defaultTab.length) {
                $defaultTab.trigger('click');
                $defaultTab.addClass('active');
            }
        }
        $tabElement.each((index, element) => {
            const $element = $(element);
            $element.on('click', () => {
                const tabValue = $element.data('tab') || '';
                this.queryValues.tab = tabValue;
                this.setUrlByTabValues(tabValue);
            });
        });
    }
    static setUrlByTabValues(tab) {
        if (!tab) {
            return;
        }
        const hash = window.location.hash;
        const newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?${new URLSearchParams({
            ...this.getAllQueryParameters(),
            ...this.queryValues,
        }).toString()}${hash}`;
        window.history.replaceState({ path: newUrl }, '', newUrl);
    }
    static getAllQueryParameters() {
        const urlSearchParams = new URLSearchParams(window.location.search);
        return Object.fromEntries(urlSearchParams.entries());
    }
    static removeAllActiveTabs($tabs) {
        $tabs.each((index, element) => {
            $(element).removeClass('active');
        });
    }
}
